<template>
  <component :is="isLink" class="w-full flex items-center bg-white" :class="isDocument" v-bind="{ to }">
    <slot name="icon" />
    <div v-if="isDefault" class="py-3 pl-2 min-w-0 w-full">
      <div class="text-left">
        <p class="text-zt-base truncate" :class="isColorActive">{{ title }}</p>
        <p class="text-left text-zt-xs text-zt-dark-500 leading-none truncate" v-if="subtitle">
          {{ subtitle }}
        </p>
      </div>
    </div>
    <slot />
  </component>
</template>

<script>
export default {
  name: 'ztListItem',
  inheritAttrs: false,
}
</script>

<style lang="css" src="../../../../../src/styles/components/ztListItem.css" scoped></style>
